export class AssignPrepsForModal {
  static $inject = ['$mdDialog'];

  // `''` - unselect option - CM
  // `'None'` - remove exisiting value - CM
  private regentsExamKeys = ['', 'None'];
  private selectedCourses = [];

  constructor(private $mdDialog) {}

  customModal = {
    controller: 'AssignPrepsForCtrl',
    template: require('.//assign-preps-for.html'),
  };

  show(regentsExamKeys, selectedCourses) {
    this.regentsExamKeys = [...regentsExamKeys];
    this.selectedCourses = [...selectedCourses];

    return this.$mdDialog.show(this.customModal);
  }

  getRegentsExamKeys() {
    return this.regentsExamKeys;
  }

  getSelectedCourses() {
    return this.selectedCourses;
  }
}

angular.module('nv.shared.modals').service('AssignPrepsForModal', AssignPrepsForModal);
